import { z } from 'zod';
import { CrossDatasetMismatchesSchema } from './cross-dataset-mismatches.schema.js';
import { DigitalFootprintFindingsSchema } from './digital-footprint-findings.schema.js';
import { RecommendedNextStepsSchema } from './recommended-next-steps.schema.js';
export const LaunderingSignalItemSchema = z.object({
    signal: z.string(),
    summary: z.string(),
    severity: z.enum([
        'low',
        'medium',
        'high',
        'critical'
    ]),
    evidence: z.array(z.string())
});
export const KeyRiskSignalsSchema = z.object({
    launderingSignals: z.array(LaunderingSignalItemSchema).nullish(),
    crossDatasetMismatches: CrossDatasetMismatchesSchema.nullish(),
    digitalFootprintFindings: DigitalFootprintFindingsSchema.nullish(),
    recommendedNextSteps: RecommendedNextStepsSchema.nullish()
}).meta({
    id: 'KeyRiskSignals'
});

//# sourceMappingURL=key-risk-signals.schema.js.map